<template>
    <div class="bodyheight grid gridchat bg-gray-100 dark:bg-black relative">
        <bg-global :bgLobby="bgLobby" />

        <ul class="bodyheight-chatbox overflow-auto chatarea flex flex-col gap-1 py-2 z-10" ref="chatbox">
            <li v-if="!messages.length"
                class="flex items-center justify-center text-sm text-red-400 dark:text-red-200 italic">
                No messages yet!
            </li>
            <li v-for="(data, index) in messages" :key="'messages-' + index"
                class="flex items-start gap-2 mx-2 p-1 rounded drop-shadow-lg"
                :class="owner(data.wallet) ? 'bg-blue-900 dark:bg-white bg-opacity-20 dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'">
                <div class="min-w-[theme('spacing[8]')] h-8 w-8 text-gray-800 dark:text-black">
                    <div v-if="!data.pfp">
                        <img class="block rounded-full object-cover w-8 h-8 border-2 border-white" src="/images/bear.jpg" />
                    </div>
                    <div v-else>
                        <img :src="data.pfp" class="block rounded-full object-cover h-8 w-8 border border-white" />
                    </div>
                </div>
                <div class="flex-1 flex flex-col">
                    <div class="text-gray-900 dark:text-inner-border text-sm">{{ data.author }}</div>
                    <div class="text-black dark:text-white text-base break-words maxwithchat">{{ data.message }}</div>
                </div>
            </li>
        </ul>
        <chat-input-box :token="token" :connected="connected" :account="account" v-cloak></chat-input-box>
    </div>
</template>

<script>
import debounce from 'lodash/debounce'
import ChatInputBox from './ChatInputBox.vue'
import { useWallet } from 'solana-wallets-vue'

export default {
    components: { ChatInputBox },
    name: 'ChatBox',
    props: ['messages', 'token', 'account', 'connected', 'bgLobby'],
    data() {
        return {
            scrolled: false,
            handleDebouncedScroll: null
        }
    },
    methods: {
        scrollToEnd() {
            if (!this.scrolled) {
                this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight
            }
        },
        owner(wallet) {
            if (!this.connected) {
                return
            }
            return wallet === useWallet().publicKey.value.toString()
        },
        handleScroll() {
            this.scrolled = this.$refs.chatbox.offsetHeight !== (this.$refs.chatbox.scrollHeight - this.$refs.chatbox.scrollTop)
        }
    },
    watch: {
        messages: {
            handler(value) {
                if (value[value.length - 1].wallet == this.account?.wallet) {
                    this.scrolled = false
                }
            },
            deep: true
        }
    },
    mounted() {
        this.handleDebouncedScroll = debounce(this.handleScroll, 100)
        this.$refs.chatbox.addEventListener('scroll', this.handleDebouncedScroll)
        this.$nextTick(() => this.scrollToEnd());
    },
    updated() {
        this.$nextTick(() => this.scrollToEnd());
    },
    beforeDestroy() {
        this.$refs.chatbox.removeEventListener('scroll', this.handleDebouncedScroll)
    }
}
</script>
